<template>
  <b-alert 
    :class="`col-12 p-1 text-left ${getVariantStatus()}`"
    show
    v-if="(is_your_proposal && proposal.state !== 'published') || (is_your_proposal) && is_editing"
  >
    <b-row class="m-0 w-100">
      <div class="avenir-medium d-flex justify-content-between align-items-center">
        <b-icon icon="exclamation-circle-fill" class="mr-05" font-scale="1.3"></b-icon>
        <div v-if="proposal.state !== 'in_review' && proposal.state !== 'changes_required'">
          {{ $t('creator.previewDescrip1') }}
        </div>
        <div v-else-if="proposal.state === 'in_review'">
          <span class="d-block avenir-bold">{{ $t('creator.proposalSumited') }}</span>
          <span>{{ $t('creator.proposalSumitDesc') }}</span>
        </div>
        <div v-else-if="proposal.state === 'changes_required'">
          <span class="d-block avenir-bold">Admin:</span>
          <span>{{proposal.changes_admin}}</span>
        </div>
      </div>
    </b-row>
  </b-alert>
</template>

<script>
import {
  BRow,
  BAlert,
  BIcon
} from 'bootstrap-vue';

export default {
  name: 'alertProposal',
  components: {
    BRow,
    BAlert,
    BIcon
  },
  props: {
    proposal: {
      type: Object,
      required: true
    },
    is_your_proposal: {
      type: Boolean,
      required: true
    },
    is_editing: {
      type: Boolean,
      required: true
    }
    
  },
  methods: {
    getVariantStatus() {
      if (this.proposal.state !== 'in_review' && this.proposal.state !== 'changes_required') return 'secondary-alert-proposal';
      else if (this.proposal.state === 'in_review') return 'info-alert-proposal'
      else if (this.proposal.state === 'changes_required') return 'warning-alert-proposal'
    },
  },
}
</script>
<style scoped>
.secondary-alert-proposal {
  background-color: #DEDEDF !important;
  color: #212529 !important;
}
.warning-alert-proposal {
  background-color: #f6e6e6 !important;
  color: #ab3b3b !important;
}
.info-alert-proposal {
  background-color: #e6f2f6 !important;
  color: #3B8DAB !important;
}
</style>w